import { QFilterGeneric } from './QFilterGeneric'

export class QFilterSortBy extends QFilterGeneric {
  name = "sort_by";
  class_name = "QFilterSortBy";
  api_name = 'sort_by';

  serialize(qfilters) {
    const sort_order = qfilters.get_filter_value('sort_desc');
    return this.value + ':' + (sort_order ? 'D' : 'A');
  }
}
